import { PatientConfig } from '../axiosConfig';

/**
 * Service to validate if the current user is still active and exists
 * This is used to check if admin has deleted the user account
 */
export const userValidationService = {
  /**
   * Validate the current user's account status
   * @returns {Promise<Object>} Validation result with isActive status
   */
  validateUser: async () => {
    try {
      const response = await PatientConfig.get('api/v1/patients/patient/validate/');
      const { StatusCode, data } = response.data;
      
      if (StatusCode === 6000) {
        return {
          success: true,
          isActive: data.is_active,
          userData: data,
          message: data.message
        };
      } else {
        return {
          success: false,
          isActive: false,
          message: data.message || 'User validation failed'
        };
      }
    } catch (error) {
      console.error('User validation error:', error);
      
      // Handle different error scenarios
      if (error.response?.status === 401) {
        return {
          success: false,
          isActive: false,
          message: 'Authentication failed. Please login again.'
        };
      } else if (error.response?.status === 403) {
        return {
          success: false,
          isActive: false,
          message: 'Access denied. Your account may have been deactivated.'
        };
      } else {
        return {
          success: false,
          isActive: false,
          message: 'Unable to validate user account. Please check your connection.'
        };
      }
    }
  }
};

export default userValidationService;
